import request from '@/utils/request'

// 学校表

let SchoolApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.school/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.school/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.school/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.school/edit', data, errorback);
    },

    /*状态*/
    status(data, errorback) {
      return request._post('/shop/study.school/status', data, errorback);
    },

    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.school/batch', data, errorback);
    },
}

export default SchoolApi;



// WEBPACK FOOTER //
// ./src/api/study/school.js